import { AtendimentoStateEnum, EstadoAtendimento } from "@/interfaces/AttendanceData";
import { api } from "./api";
import UserService from "../UserService";
import briefingApi from "./briefing";
import clientApi from "./client";
import attendantApi from "./attendant";
import { ReqPaginadoKanban } from "@/utils/Types/ReqPaginadoKanban";

export const getAttendance = async (id: number) => {
  return api.get(`/attendance/${id}`);
};

export const buscarAtendimentoPorCliente = async (cliente_id: number) => {
  return api.get(`/attendance/atendimentosPorCliente/${cliente_id}`);
}

export const createAttendance = async (
  client_id: number,
  attendant_id: any
) => {
  return api.post(`/attendance/create`, { client_id, attendant_id });
};

export const updateAttendanceKanban = async (
  atendimento_id: any,
  estado: AtendimentoStateEnum,
  attendanceState : EstadoAtendimento
) => {
  return api.patch(`/attendance/update/${atendimento_id}`, {
    kanbanState: estado,
    state: attendanceState.estado
  });
}

export const alterarStatusProjetoTecnico = async (
  atendimento_id: any,
  statusProjeto: string
) => {
  return api.patch(`/attendance/alterarStatusProjetoTecnico/${atendimento_id}`, {
    statusProjeto
  });
}

export const updateAttendance = async (
  atendimento_id: any,
  estado: EstadoAtendimento
) => {
  console.log(estado);

  return api.patch(`/attendance/update/${atendimento_id}`, {
    state: estado.estado,
  });
};

export async function createAttendanceWithClient(lead: any) {
  try {
    // Verificar se o cliente já existe pelo telefone
    const findResponse = await clientApi.findByPhone(lead.telefone);
    let clientId;

    if (findResponse.status === 200 && findResponse.data) {
      clientId = findResponse.data.id;
    } else {
      // Cliente não existe, criar um novo
      const newClientData = {
        dataClient: {
          nome: lead.nome,
          telefone: lead.telefone,
          email: null,
          cpf: null,
        },
        dataAddress: null,
        dataDeliveryAddress: null,
      };

      const createResponse = await clientApi.create(newClientData);
      if (createResponse.status !== 201 && createResponse.status !== 200) {
        throw new Error("Erro ao criar o cliente");
      }

      clientId = createResponse.data.response.client.id;
    }

    // Criar atendimento
    const userId = UserService.getUser()?.userId;
    if (!userId) throw new Error("Não há informação de userId");

    const attendantResponse = await attendantApi.getAttendantByUserId(userId);
    if (attendantResponse.status === 500)
      throw new Error("Erro ao recuperar atendente");

    const attendant = attendantResponse.data;
    if (!attendant) throw new Error("Erro ao recuperar dados do atendente");

    const attendanceResponse = await api.post(`/attendance`, {
      clientId,
      attendantId: attendant.id,
    });
    if (attendanceResponse.status === 500)
      throw new Error("Erro ao criar atendimento");

    const attendanceId = attendanceResponse.data.id;

    // Criar briefing
    const briefingResponse = await briefingApi.createBriefing(attendanceId);
    if (briefingResponse.status === 500 || !briefingResponse.data)
      throw new Error("Erro ao criar briefing");

    return {
      success: true,
      clientId,
    };
  } catch (error) {
    console.error("Erro ao criar atendimento e briefing:", error);
    throw error;
  }
}

export async function buscarClientePorNomeOuTelefone(nome?: string, telefone?: string, arquivamento?: boolean) {
  return await api.get(`/attendance/filtroNomeTelefone`, { params: { nome, telefone, arquivamento } });
}

export async function atualizarArquivamento(atendimentoId?: string | number, arquivamento?: boolean) {
  return await api.patch(`/attendance/atualizarArquivamento`, { id: atendimentoId, arquivamento });
}

export async function listAttendances(
  atendente_id?: string,
  arquivamento?: any, 
  pagina? : number, 
  quantidade? : number
) {
  return api.get(`/attendance/list`, { params: { atendente_id, arquivamento, pagina, quantidade } });
};

async function atualizarEstadoAtendimento(atendimento_id: string, estado: string) {
  return await api.patch(`/attendance/atualizaEstadoAtendimento/${atendimento_id}`, { estado });
}

async function atualizarMensagemAtendimento(atendimento_id: string, estado?: string, mensagem?: string, dataEnvio?: string) {
  return await api.patch(`/attendance/atualizarMensagemAtendimento/${atendimento_id}`, { estado, mensagem, dataEnvio });
}

async function atualizarTituloAtendimento(atendimento_id: string, titulo: string) {
  return await api.patch(`/attendance/atualizarTitulo/${atendimento_id}`, { titulo });
}

async function getByEstadoKanban(
  param : ReqPaginadoKanban
) {
  return await api.get(`/attendance/listEstadoKanban`, { params: { 
    estadoKanban: param.estado, 
    atendentes : param.atendentes?.toString(), 
    criadoEm : param.criadoEm, 
    searchTerm : param.searchTerm, 
    startDate: param.startDate,
    endDate: param.endDate,
    arquivamento : param.arquivamento, 
    pagina : param.pagina, 
    quantidade : param.quantidade,
    atendente_id: param.atendente_id
   } });
}

async function getNpsAtendimentos(params?: object){
  return await api.get('attendance/listar-nps-atendimentos', 
    { params }
  )
}

async function getFeedback(atendimento_id: number) {
  return await api.get(`attendance/feedback/${atendimento_id}`)
}

const attendanceApi = {
  getAttendance,
  createAttendance,
  listAttendances,
  updateAttendanceKanban,
  alterarStatusProjetoTecnico,
  updateAttendance,
  createAttendanceWithClient,
  buscarAtendimentoPorCliente,
  buscarClientePorNomeOuTelefone,
  atualizarArquivamento,
  atualizarEstadoAtendimento,
  atualizarMensagemAtendimento,
  atualizarTituloAtendimento,
  getByEstadoKanban,
  getNpsAtendimentos,
  getFeedback
};

export default attendanceApi;
